import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const SEVERITIES = {
    ok: { background: "var(--pw-success-bg)", foreground: "var(--pw-success-fg)" },
    warning: { background: "var(--pw-warning-bg)", foreground: "var(--pw-warning-fg)" },
    error: { background: "var(--pw-danger-bg)", foreground: "var(--pw-danger-fg)" },
};

const Pill = styled.span`
    display: inline-flex;
    align-items: center;
    /* Grid and flex parents stretch their children, which would smear the pill
       across a whole table cell. */
    justify-self: start;
    align-self: center;
    width: fit-content;
    gap: var(--gap-s);
    padding: 4px 10px;
    border-radius: var(--pw-radius-pill);
    font-size: var(--pw-text-sm);
    font-weight: var(--pw-weight-semibold);
    line-height: var(--pw-leading-snug);
    white-space: nowrap;
    background: ${(props) => SEVERITIES[props.$severity].background};
    color: ${(props) => SEVERITIES[props.$severity].foreground};
`;

const Blip = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    flex: none;
`;

export const PathwayStatusPill = ({ children, severity = "ok", dataCy }) => (
    <Pill $severity={SEVERITIES[severity] ? severity : "ok"} data-cy={dataCy}>
        <Blip aria-hidden="true" />
        {children}
    </Pill>
);

PathwayStatusPill.propTypes = {
    children: PropTypes.node.isRequired,
    severity: PropTypes.oneOf(["ok", "warning", "error"]),
    dataCy: PropTypes.string,
};

export default PathwayStatusPill;
